export { default } from './InputArray';
